export default "__VITE_ASSET__DR38xjH0__"